import { log } from "./Logging";
/**
 * A collection of utilities to help connect to the platform
 */

export const handleAjaxError = (error, className) => {
  let loggerName = "handleAjaxError";
  if (className) {
    loggerName = className;
  }
  const logger = log.getLogger(loggerName);
  try {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      logger.error(`Platform request failed: ${error.response.config.url}`);
      logger.error("%o", error.response.data);
      logger.error(`Platform HTTP Status ${error.response.status} ${error.response.statusText}`);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      logger.error("Platform request error", error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      logger.error("Error", error.message);
    }
  } catch (error) {
    logger.error("Fail to process Error! whoops", error.message);
  }
};